/**
 * TanStack Query hooks for admin dashboard stats.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';

export interface UpcomingClass {
  id: string;
  code: string;
  name: string;
  branchName: string;
  startDate: string;
  currentEnrollment: number;
  capacity: number;
}

export interface DashboardStats {
  counts: {
    branches?: number;
    classes: number;
    students: number;
  };
  upcomingClasses: UpcomingClass[];
}

export const dashboardKeys = {
  admin: (branchId?: string | null) =>
    ['dashboard', 'admin', branchId] as const,
};

export function useAdminDashboard(branchId?: string | null) {
  return useQuery({
    queryKey: dashboardKeys.admin(branchId),
    queryFn: () =>
      api.get<DashboardStats>('/api/dashboard/admin', {
        ...(branchId ? { branchId } : {}),
      }),
  });
}
